import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BetaShowcasePage } from "@/pages/BetaShowcasePage";
import "@/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BetaShowcasePage />
  </StrictMode>
);
